export default __webpack_public_path__ + "static/media/license.2c4aedb5.svg";